const ErrorComponent = () => {
    return <h1>Something went wrong</h1>;
  };

  export default ErrorComponent;